import { PERMISSIONS } from 'store/baseConfig';

export const AUTH_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.SUPER_ADMIN, PERMISSIONS.ADMIN, PERMISSIONS.USER]
};

export const SUPER_ADMIN_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.SUPER_ADMIN]
};

export const ADMIN_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.ADMIN]
};

export const USER_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.USER]
};

export const SUPER_ADMIN_AND_ADMIN_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.SUPER_ADMIN, PERMISSIONS.ADMIN]
};

export const SUPER_ADMIN_AND_USER_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.SUPER_ADMIN, PERMISSIONS.USER]
};

export const ADMIN_AND_USER_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.ADMIN, PERMISSIONS.USER]
};

// 역할별 모바일 조건 설정
// ADMIN: 모바일이 아닌 경우만 접근 가능 (mobileLoginRequired: false)
// USER: 모바일인 경우만 접근 가능 (mobileLoginRequired: true)
export const ADMIN_AND_USER_MOBILE_RULES = {
    protected: true,
    allowedRoles: [PERMISSIONS.ADMIN, PERMISSIONS.USER],
    mobileLoginRules: {
        [PERMISSIONS.ADMIN]: false,  // ADMIN은 모바일이 아닌 경우만
        [PERMISSIONS.USER]: true     // USER는 모바일인 경우만
    }
};



